<template>
    <ProductCard
        :product-id="productData.hotel_id"
        product-type="hotel"
        :product-location-type="airportData.content.type"
        :product-image="optimizedImage.large"
        :product-link="relativeLink(productData.info.url)"
        :product-name="productData.name"
        :product-stars-rating="productData.overview.rating_by_customers.outOfFiveFraction"
        :product-rating="ratingAccurate"
        :product-rating-count="productData.overview.surveys_count"
        :product-distance="productData.overview.distance_to_airport?.toFixed(1)"
        :airport-code="airportData.content?.code"
        :product-shuttle-option="productData.info?.shuttle_free"
        :product-shuttle-free-only="true"
        :product-options="productData.options"
        card-type="HotelProductCard"
        :free-cancellation="true"
    />
</template>

<script setup lang="ts">
import ProductCard from '../cards/ProductCard.vue';

const props = defineProps<{
    blok: any;
    productData: any;
    airportData?: any;
}>();

const img = useImage();

const ratingAccurate = parseFloat(props.productData.overview.rating_by_customers.accurate?.toFixed(1));

const optimizedImage = computed(() => {
    const largeImgUrl = img(`${props.productData.images.large_url}/${props.productData.images?.data[0]}`, {
        format: 'webp',
        height: 200,
    });
    const mediumImgUrl = img(`${props.productData.images.medium_url}/${props.productData.images?.data[0]}`, {
        format: 'webp',
        height: 200,
    });
    return { large: largeImgUrl, medium: mediumImgUrl };
});

function relativeLink(link: string) {
    const fullUrl = new URL(link);
    const prefix = typeof window !== 'undefined' ? window.location.origin : '';
    return prefix + '/psf' + fullUrl.pathname;
}
</script>

<style lang="postcss" scoped></style>
